export default __webpack_public_path__ + "media/images/jvqmap/marker/red-1b009f2566b5108465af0b471ce9c929.png";